import type { VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const NewDocumentTemplatePage_DocumentTemplate_Create_Mutation = graphql(
  `
    mutation NewDocumentTemplatePage_DocumentTemplate_Create(
      $documentTemplate: DocumentTemplateInput!
      $versionData: VersionDataInput
    ) {
      createDocumentTemplate(
        doc: $documentTemplate
        versionData: $versionData
      ) {
        _id
      }
    }
  `,
);

export type DocumentTemplateInput = VariablesOf<
  typeof NewDocumentTemplatePage_DocumentTemplate_Create_Mutation
>['documentTemplate'];

export const useCreateDocumentTemplateMutation = () =>
  useGraphQLMutation(NewDocumentTemplatePage_DocumentTemplate_Create_Mutation);
